import React from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Button from '../../../components/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ProviderAPI } from '../../../api';

const CreateProviderDialog = ({open, setOpen, onCreated}) => {
  const [providerName, setProviderName] = useState('');
  const [busy, setBusy] = useState(false);
  const close = () => setOpen(false);

  const createProvider = async () => {
    setBusy(true);
    try {
      const { payload } = await ProviderAPI.createProvider({name: providerName});
      const { uuid } = payload;
      setBusy(false);
      setOpen(false);
      onCreated(uuid);
    } catch (err) {
      console.error(err);  // eslint-disable-line no-console
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={close} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">New Provider Organisation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          A new provider organisation will be created with no associated users.
        </DialogContentText>
        <TextField
          autoFocus={true}
          margin="dense"
          label="Organisation Name*"
          type="text"
          fullWidth
          onChange={e => setProviderName(e.target.value.trim())}
          onKeyUp={e => e.keyCode === 13 && providerName !== '' && createProvider()}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="outlined" color="primary" label="Cancel" pointer="none">
          Cancel
        </Button>
        <Button onClick={createProvider} color="primary" label="Create" disabled={providerName === ''} busy={busy}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CreateProviderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onCreated: PropTypes.func.isRequired,
};

export default CreateProviderDialog;
